import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./Home";
import Login from "./Login";
import Chat from "./Chat";
import Bikes from "./Bikes";
import RoutesPage from "./RoutesPage";
import Shop from "./Shop";
import SOS from "./SOS";
import Calculator from "./Calculator";
import BikeCompare from "./BikeCompare";
import MechanicFinder from "./MechanicFinder";
import MechanicGarage from "./MechanicGarage";
import MechanicApproval from "./MechanicApproval";
import AdminDashboard from "./AdminDashboard";
import Rides from "./Rides";
import EmiCalculator from "./calculators/EmiCalculator";
import FuelCalculator from "./calculators/FuelCalculator";
import TripCalculator from "./calculators/TripCalculator";
import InsuranceCalculator from "./calculators/InsuranceCalculator";
import OnRoadPriceCalculator from "./calculators/OnRoadPriceCalculator";
import ResaleValueCalculator from "./calculators/ResaleValueCalculator";
import MaintenanceCostCalculator from "./calculators/MaintenanceCostCalculator";
import Blogs from "./Blogs";
import BlogDetail from "./BlogDetail";
import WriteBlog from "./WriteBlog";
import LoanOffers from "./LoanOffers";
import InsuranceOffers from "./InsuranceOffers";
import BudgetPlanner from "./BudgetPlanner";
import BikeRecommendation from "./BikeRecommendation";
import Profile from "./Profile";
import About from "./About";
import Feedback from "./Feedback";
import RidersDirectory from "./RidersDirectory";
import RiderProfile from "./RiderProfile";
import BikePrices from './BikePrices';
import ShowroomDirectory from "./ShowroomDirectory";
import ShowroomDetail from "./ShowroomDetail";
import ShowroomOwnerDashboard from "./ShowroomOwnerDashboard";
import ShowroomAdminDashboard from "./ShowroomAdminDashboard";
import ShowroomsSearch from "./ShowroomsSearch";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blog/write" element={<WriteBlog />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/budget" element={<BudgetPlanner />} />
     <Route path="/bike-prices" element={<BikePrices />} />
      <Route path="/loans" element={<LoanOffers />} />
      <Route path="/insurance" element={<InsuranceOffers />} />
      <Route path="/recommend" element={<BikeRecommendation />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/bikes" element={<Bikes />} />
      <Route path="/routes" element={<RoutesPage />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/sos" element={<SOS />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/calculator" element={<Calculator />} />
      <Route path="/mechanic-finder" element={<MechanicFinder />} />
      <Route path="/mechanic-finder/:citySlug" element={<MechanicFinder />} />
      <Route path="/my-garage" element={<MechanicGarage />} />
      <Route path="/mechanic-approval" element={<MechanicApproval />} />
      <Route path="/admin-dashboard" element={<AdminDashboard />} />
      <Route path="/calculator/emi" element={<EmiCalculator />} />
      <Route path="/calculator/fuel" element={<FuelCalculator />} />
      <Route path="/calculator/trip" element={<TripCalculator />} />
      <Route path="/calculator/insurance" element={<InsuranceCalculator />} />
      <Route path="/calculator/onroad" element={<OnRoadPriceCalculator />} />
      <Route path="/calculator/resale" element={<ResaleValueCalculator />} />
      <Route path="/calculator/maintenance" element={<MaintenanceCostCalculator />} />
      <Route path="/compare" element={<BikeCompare />} />
      <Route path="/compare/:slug" element={<BikeCompare />} />
      <Route path="/rides" element={<Rides />} />
      <Route path="/riders" element={<RidersDirectory />} />
      <Route path="/riders/:username" element={<RiderProfile />} />
      <Route path="/showrooms" element={<ShowroomDirectory />} />
      <Route path="/showrooms/:stateSlug" element={<ShowroomDirectory />} />
      <Route path="/showrooms/:stateSlug/:citySlug" element={<ShowroomDirectory />} />
      <Route path="/search" element={<ShowroomsSearch />} />
      <Route path="/showroom/:slug" element={<ShowroomDetail />} />
      <Route path="/showroom-owner" element={<ShowroomOwnerDashboard />} />
      <Route path="/showroom-admin" element={<ShowroomAdminDashboard />} />
      <Route path="/about" element={<About />} />
      <Route path="/feedback" element={<Feedback />} />
    </Routes>
  );
}
